import createTurnoForm from './createTurnoFormModel';
const {
  formField: {
    // DATOS TURNOS 
    cargo,
    start_hour,
    end_hour,
    dia,
    tarde,
    noche,
    tarifa,
    anio,
    lunes,
    martes,
    miercoles,
    jueves,
    viernes,
    sabado,
    domingo,
    festivo,

  } 
} = createTurnoForm;

export default {

  [cargo.name]: null,
  [start_hour.name]: null,
  [end_hour.name]: null,
  [dia.name]: '',
  [tarde.name]: '',
  [noche.name]: '',
  [tarifa.name]: '',
  [anio.name]: '',
  [lunes.name]: false,
  [martes.name]: false,
  [miercoles.name]: false,
  [jueves.name]: false,
  [viernes.name]: false,
  [sabado.name]: false,
  [domingo.name]: false,
  [festivo.name]: false,

};

